(function() {

	angular
		.module('ngmvac')
		.factory('FacturacionFactory', FacturacionFactory);

	FacturacionFactory.$inject = ['$http'];

	function FacturacionFactory($http) {

        return{
            envio   	  : envio,
			country 	  : country,
			state 		  : state,
			municipality  : municipality,
			insertar	  : insertar,
			selectRFC	  : selectRFC
        }
        function envio(params){
            
			return $http.post('/Facturacion/login', params);
		}

		function country(){
			return $http.get('/Facturacion/paises');
		}

		function state(){
			return $http.get('/Facturacion/estados');
		}

		function municipality(){
			return $http.get('/municipios.json');
		}

		 function insertar(params){
			 return $http.post('/Facturacion/insertar', params);
		 }

		 function selectRFC(param){
			 return $http.post('/Facturacion/Select', {params:{'rfc_selec':param}});
		 }
		  
    }
})();
